import { render, staticRenderFns } from "./LiveChatMessage.vue?vue&type=template&id=dea4dd00&scoped=true&"
import script from "./LiveChatMessage.vue?vue&type=script&lang=js&"
export * from "./LiveChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMessage.vue?vue&type=style&index=0&id=dea4dd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4dd00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VTextField})
